<template>
  <section
    :class="['record wrapper', taskDimension && 'record__tile']"
    v-if="actData.invitationInfos"
  >
    <section class="content">
      <h3 class="title">
        我的邀请记录
        <router-link
          tag="span"
          :to="{ path: 'my_awards', query: $route.query }"
          @click.native="linkView"
          >奖励明细
          <img
            v-show="taskDimension"
            src="../assets/images/invite_detail.png"
            alt=""
        /></router-link>
      </h3>
      <ul class="record-desc">
        <li class="total-money">
          <p class="num money">
            <span class="integer">{{
              actData.invitationInfos.totalCurrency | filterInteger
            }}</span>

            <span
              >{{
                actData.invitationInfos.totalCurrency | filterDecimal
              }}元</span
            >
          </p>
          <p class="desc">累计获得金额</p>
        </li>
        <template v-if="!taskDimension">
          <li class="inprogress">
            <p class="num">
              {{ actData.invitationInfos.inprogressInvite }}<span>人</span>
            </p>
            <p class="desc">进行中的人数</p>
          </li>
          <li class="complete">
            <p class="num">
              {{ actData.invitationInfos.completeInviteTasks }}<span>个</span>
            </p>
            <p class="desc">成功邀请任务</p>
          </li>
        </template>
        <template v-if="taskDimension">
          <li class="complete">
            <p class="num">
              {{ actData.invitationInfos.successCompleteTaskInvitee
              }}<span>个</span>
            </p>
            <p class="desc">成功邀请人数</p>
          </li>
        </template>
      </ul>
      <RecordList :taskDimension="taskDimension" />
    </section>
  </section>
</template>
<script>
import { mapState } from 'vuex';
import RecordList from './RecordList';
const TASK_DIMENSION_ID = 1058;
export default {
  components: { RecordList },
  props: ['id'],
  mounted() {
    console.log(this.id, 'props--->');
  },
  computed: {
    ...mapState('app', ['actData', 'businessType']),
    taskDimension() {
      return this.id == TASK_DIMENSION_ID;
    }
  },
  filters: {
    filterDecimal(value) {
      value = `${value / 100}`;
      let res = value.split('.')[1] ? value.split('.')[1] : '00';
      return '.' + res;
    },
    filterInteger(value) {
      value = `${value / 100}`;
      return value.split('.')[0];
    }
  },
  methods: {
    linkView() {
      let moduleName = '奖励明细',
        params = {};
      this.trackLog(moduleName, false, params);
    }
  }
};
</script>
<style lang="less" scoped>
.record {
  &.wrapper {
    // background: #fff2da;
    padding: 20px 27px;
    .content {
      background: #ffffff;
      border-radius: 16px;
      // box-shadow: 0px 0px 40px 0px rgba(255, 106, 24, 0.16);
      font-family: Source Han Sans SC Bold, Source Han Sans SC Bold-Bold;
      color: #181d37;
      padding: 35px;
      letter-spacing: 1;
      .title {
        font-size: 42px;
        font-weight: 700;
        font-family: Source Han Sans SC Bold, Source Han Sans SC Bold-Bold;
        .fc;
        justify-content: space-between;
        > span {
          background: #fff1de;
          border-radius: 16px;
          padding: 11px 20px;
          font-size: 28px;
          font-family: Source Han Sans SC Medium,
            Source Han Sans SC Medium-Medium;
          font-weight: 500;
          color: rgba(174, 0, 0, 0.7);
          .fc;
          > img {
            width: 18px;
            margin-left: 6px;
          }
        }
      }
      > .record-desc {
        padding: 40px 10px 40px;
        .fc;
        justify-content: space-around;
        > li {
          .fcsc;
          > .num {
            font-size: 60px;
            font-family: TG-TYPE-Bold;
            font-weight: 700;
            color: #ff5926;

            > span {
              font-size: 36px;
              font-weight: 500;
            }
          }
          > .money {
            .integer {
              font-size: 60px;
              font-family: TG-TYPE-Bold;
              font-weight: 700;
              color: #ff5926;
            }
          }
          > .desc {
            font-size: 28px;
            font-family: Source Han Sans SC Medium,
              Source Han Sans SC Medium-Medium;
            font-weight: 500;
            text-align: left;
            color: rgba(24, 29, 55, 0.85);
          }
          &.complete {
            .num {
              color: #181d37;
              > span {
                color: rgba(24, 29, 55, 0.85);
              }
            }
          }
        }
      }
    }
  }
  &.record__tile {
    .content {
      border-radius: 16px;
      > .record-desc {
        padding-bottom: 50px;
        > li {
          > .desc {
            color: rgba(38, 38, 38, 0.85);
          }
          &.complete {
            .num {
              color: #181d37;
              > span {
                color: rgba(38, 38, 38, 0.85);
              }
            }
          }
        }
      }
    }
  }
}
</style>
